// Обезличенная статистика: события уходят на сервер фоном и не мешают работе сайта.
// Первое событие сессии — «визит»: откуда пришли (только домен), метки UTM, страница входа, устройство, язык.
const ENDPOINT = '/api/events';
const STAGE: Record<string, string> = {
  visit: 'visit', search_flight: 'search', search_train: 'search', search_hotel: 'search', ai_search: 'search',
  view_ticket: 'view', view_rooms: 'view', click_buy: 'click', book_open: 'book', lead: 'lead',
};

const session = {
  get(k: string): string | null { try { return sessionStorage.getItem(k); } catch { return null; } },
  set(k: string, v: string): void { try { sessionStorage.setItem(k, v); } catch { /* нет хранилища */ } },
};

export function track(event: string, props: Record<string, unknown> = {}): void {
  try {
    const p: Record<string, unknown> = { ...props };
    const utm = session.get('utm');
    if (utm) p.utm = utm;
    // Воронка: каждый этап отмечаем один раз за сессию
    const stage = STAGE[event];
    if (stage) {
      const done = (session.get('funnel') || '').split(',');
      if (!done.includes(stage)) { p.f = 1; session.set('funnel', [...done, stage].filter(Boolean).join(',')); }
    }
    const body = JSON.stringify({ event, props: p });
    if (navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'application/json' }))) return;
    fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true }).catch(() => {});
  } catch {
    // статистика не должна ломать сайт
  }
}

interface TelegramWindow { Telegram?: { WebApp?: { initData?: string } } }

/** Визит: один раз за сессию браузера */
export function trackVisit(): void {
  if (session.get('visit')) return;
  session.set('visit', '1');
  const q = new URLSearchParams(location.search);
  const src = q.get('utm_source');
  if (src) session.set('utm', [src, q.get('utm_medium') || '', q.get('utm_campaign') || ''].map((x) => x.slice(0, 40)).join('|'));
  let ref = '';
  try { const h = new URL(document.referrer).hostname; if (h !== location.hostname) ref = h; } catch { /* нет referrer */ }
  const tgw = (window as unknown as TelegramWindow).Telegram;
  const tg = /tgWebApp/.test(location.hash + location.search) || Boolean(tgw && tgw.WebApp && tgw.WebApp.initData);
  const path = location.pathname;
  const landing = tg ? 'tg' : path.startsWith('/p/') ? 'pick' : path.startsWith('/r/') ? 'route' : path.startsWith('/t/') ? 'train' : path === '/' ? 'main' : 'other';
  const w = Math.min(screen.width || innerWidth, innerWidth);
  const device = /iPad|Tablet/i.test(navigator.userAgent) || (w >= 600 && w < 1024 && 'ontouchstart' in window) ? 'tablet'
    : w < 600 || /Mobi|Android|iPhone/i.test(navigator.userAgent) ? 'mobile' : 'desktop';
  track('visit', { ref, landing, device, lang: String(navigator.language || '').slice(0, 2).toLowerCase() });
}

// Домен партнёра; партнёрские ссылки Travelpayouts (tp.st, tp.media) ведут на адрес из параметра u
function partnerOf(a: HTMLAnchorElement): string {
  let host = a.hostname;
  if (/(^|\.)tp\.(st|media)$/.test(host)) {
    try { host = new URL(new URL(a.href).searchParams.get('u') || '').hostname || host; } catch { /* оставляем домен ссылки */ }
  }
  return host.replace(/^www\./, '');
}

// Переходы на покупку: один обработчик на весь документ, вид определяем по месту ссылки
const KINDS: [string, string][] = [
  ['.offer', 'offer'],
  ['.bk-rail-buy', 'train'],
  ['.train-card, #train-buy, [data-panel="trains"]', 'train'],
  ['#rooms-dialog, .hotel, [data-panel="hotels"]', 'hotel'],
  ['#ticket-dialog, .ticket, [data-panel="flights"], [data-panel="pick"]', 'flight'],
];

let buyTracking = false;

export function trackBuyClicks(): void {
  if (buyTracking) return;
  buyTracking = true;
  document.addEventListener('click', (e) => {
    const target = e.target instanceof Element ? e.target : null;
    const a = target?.closest<HTMLAnchorElement>('a[href^="http"]');
    if (!a || a.origin === location.origin) return;
    if (!a.matches('[rel~="sponsored"], .btn, #train-buy, .all-link')) return;
    const kind = (KINDS.find(([sel]) => a.closest(sel)) || [])[1];
    if (kind) track('click_buy', { kind, partner: partnerOf(a) });
  }, true);
}
